<ada-card
	#RealTimePropertiesCard
	id="RealTimePropertiesCard"
	width="100%"
	[collapseEnabled]="true"
	[verticalSpacing]="'Small'"
>
	<ada-text
		content="Real Time Properties"
		data-container-selector="ada-card-header"
		id="RealTimePropertiesCardHeader"
	/>
	<ada-container
		data-container-selector="ada-card-body"
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[colCount]="4"
		[padding]="defaultCardPadding"
	>
		<ng-container *ngIf="'RegistryIndicators' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#RegistryIndicatorsLabel
				content="Registry Indicators"
				id="RegistryIndicatorsLabel"
				[inheriting]="currentPropertyObject?.RegistryIndicators | inheritPipe: inheritedPropertyObject?.RegistryIndicators"
				[isDisabled]="isDisabled"
				[isRequired]="'RegistryIndicators' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('RegistryIndicators')"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					id="RegistryIndicatorsInput"
					[addButtonText]="'Add Registry Indicator'"
					[isDisabled]="isDisabled"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="
						!(currentPropertyObject?.RegistryIndicators | inheritPipe)
							? currentPropertyObject?.RegistryIndicators
							: inheritedPropertyObject?.RegistryIndicators
					"
					(valueChange)="setObjectPropertyValue('RegistryIndicators', $event)"
				/>
			</ada-container>
		</ng-container>
		<ng-container *ngIf="'FolderIndicators' | displayAuthoringProperty: editorClass : propertyConstructor.namespace">
			<ada-authoring-property-label
				#FolderIndicatorsLabel
				content="Folder Indicators"
				id="FolderIndicatorsLabel"
				[inheriting]="currentPropertyObject?.FolderIndicators | inheritPipe: inheritedPropertyObject?.FolderIndicators"
				[isDisabled]="isDisabled"
				[isRequired]="'FolderIndicators' | isRequiredProperty: editorClass : propertyConstructor.namespace"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
				(inheritanceChange)="deleteObjectPropertyValue('FolderIndicators')"
			/>
			<ada-container
				[colCount]="2"
				[colSpan]="3"
				[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
			>
				<ada-list-builder
					id="FolderIndicatorsInput"
					[addButtonText]="'Add Folder Indicator'"
					[isDisabled]="isDisabled"
					[responsiveConfiguration]="UI.ResponsiveConfig.DEFAULT_WRAPPED_FIELD_CONFIG"
					[value]="
						!(currentPropertyObject?.FolderIndicators | inheritPipe)
							? currentPropertyObject?.FolderIndicators
							: inheritedPropertyObject?.FolderIndicators
					"
					(valueChange)="setObjectPropertyValue('FolderIndicators', $event)"
				/>
			</ada-container>
		</ng-container>
	</ada-container>
</ada-card>
